<div class="searchForm flex-row" #myForm id="formMinAnnonce">
    <div class="form-row formTile">
        <div class="col-12"><i class="fas fa-cogs"></i> Place : </div>
    </div>
  <div class="form-row">
      <div class="col-2">
        <label  for="Description" >Label</label>
      </div>
      <div class="col-6">
        <input type="text" [(ngModel)]="place.label" class="form-control mb-2" id="Description" placeholder="Description ">
      </div>
    </div>
    <div class="form-row">
        <div class="col-2">
          <label  for="Description" >Adresse</label>
        </div>
        <div class="col-6">
          <input type="text" [(ngModel)]="place.street" class="form-control mb-2" id="street" placeholder="Adresse ">
        </div>
      </div>
    <div class="form-row">
        <div class="col-2">
            <label  for="Description" >Configuration </label>
        </div>
        <div class="col-6">

            <ng-select class="mb-2" [ngModelOptions]="{standalone: true}"
            dropdownPosition='bottom' placeholder="configuration"
              [items]="configs" [multiple]="false"
              [readonly]="!this.placeId && this.upperConfigId"
              [bindLabel]="'label'"
              [closeOnSelect]="true" bindValue="id" [(ngModel)]="placeConfigId"
              name="selectConfig">
            </ng-select>
        </div>
    </div>
    <div class="form-row">
        <div class="col-2">
            <label  for="Description" >Status</label>
        </div>
        <div class="col-6">
            <div class="item_categorie">
                <div *ngIf="place.busy">
                    <p>Place Occupée
                    <span [class]="countDownColor" id="countDown"> {{(countDown)}}</span>
                  </p>
                </div>
                <div *ngIf="!place.busy">
                    <p>Place Libre
                    <span [class]="countDownColor"  id="countDown"> {{(countDown)}}</span>
                  </p>
                </div>
            </div>
        </div>
      </div>

  <div class="form-row justify-content-center">
    <div class=" col-2">
        <button type="button"
        class="btn  btn-secondary btn-sm btn-block"
        [routerLink]="['/administration']"
        style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
        >Annuler</button>
    </div>
    <div class=" col-2">
      <button type="button" (click)="savePlace()"
      class="btn btn-indigo btn-sm btn-block"
      style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
      >Valider</button>
  </div>
  </div>
</div>
